import React, { useState } from 'react';
import { Card, Tabs } from '@otp/ui';
import clsx from 'clsx';
import { User as UserModel } from 'src/graphql/generated/graphql';
import { RestaurantAssignedList } from './restaurants/restaurants-assigned-list';
import { RestaurantUnassignedList } from './restaurants/restaurants-unassigned-list';
import { UserCard } from './user-card';
import { ContentWrapper } from 'src/components/common/wrapper/content/wrapper';

import styles from './index.module.css';
import { useAuthContext } from 'src/context/auth.context';
import { PermissionsAssigned } from './permissions/permissions-assigned';
import { useTranslation } from 'react-i18next';
import { UserCertificates } from 'src/components/organisation/manage-otps/user-details/user-certificates/user-certificates';
import { UserUserGroups } from 'src/components/organisation/manage-otps/user-details/user-groups/user-user-groups';
import { UserActions } from './user-actions';

type UserDetailsProps = {
  user: Partial<UserModel>;
};

enum TabType {
  Stores = 'stores',
  Permissions = 'permissions',
  Certificates = 'certificates',
}

export const UserDetails = ({ user }: UserDetailsProps) => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState(TabType.Stores);

  const { isAdmin, isOtpPro } = useAuthContext();

  const getAvailableTabs = () => {
    const tabs = [{ label: t('common.stores'), value: TabType.Stores }];

    if (isAdmin) {
      tabs.push(
        { label: t('common.permissions'), value: TabType.Permissions },
        { label: t('common.certificates'), value: TabType.Certificates },
      );
    } else if (isOtpPro) {
      tabs.push({
        label: t('common.certificates'),
        value: TabType.Certificates,
      });
    }

    return tabs;
  };

  const TABS = getAvailableTabs();

  return (
    <ContentWrapper>
      <Card
        noBorder
        className="bg-white flex grow gap-6 w-full flex-col md:flex-row p-3.5 md:p-4"
      >
        <div className="flex flex-col ">
          <UserCard user={user} />
          <UserActions user={user} />
        </div>
        <div
          className={clsx(
            'flex flex-col grow gap-6',
            styles.userDetailsTableWrapper,
          )}
        >
          <Tabs
            tabs={TABS}
            onChange={(_, value) => setActiveTab(value)}
            value={activeTab}
          />
          {activeTab === TabType.Stores && (
            <>
              <RestaurantAssignedList user={user} />
              <RestaurantUnassignedList user={user} />
            </>
          )}
          {activeTab === TabType.Permissions && (
            <>
              <PermissionsAssigned user={user} />
              <UserUserGroups userId={user.id} />
            </>
          )}
          {activeTab === TabType.Certificates && (
            <UserCertificates userId={user.id} />
          )}
        </div>
      </Card>
    </ContentWrapper>
  );
};
